module.exports = __webpack_public_path__ + "img/kz.765c10f3.svg";